"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var vdl_prefix_1 = require("../util/vdl-prefix");
var classnames_1 = require("../util/classnames");
function calcPoints(vertical, marks, dots, step, min, max) {
    if (step == null || step <= 0) {
        throw new Error('`Slider[step]` should be a positive number in order to make Slider[dots] work.');
    }
    var points = Object.keys(marks).map(parseFloat);
    if (dots) {
        for (var i = min; i <= max; i = i + step) {
            if (points.indexOf(i) >= 0)
                continue;
            points.push(i);
        }
    }
    return points;
}
var Steps = /** @class */ (function (_super) {
    __extends(Steps, _super);
    function Steps() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Steps.prototype.render = function () {
        var _a = this.props, vertical = _a.vertical, marks = _a.marks, dots = _a.dots, step = _a.step, max = _a.max, min = _a.min, included = _a.included, upperBound = _a.upperBound, lowerBound = _a.lowerBound;
        var range = max - min;
        var elements = calcPoints(vertical, marks, dots, step, min, max)
            .map(function (point) {
            var offset = Math.abs(point - min) / range * 100 + "%";
            var style = vertical ? { bottom: offset } : { left: offset };
            var isActive = (!included && point === upperBound) ||
                (included && point <= upperBound && point >= lowerBound);
            var pointClassName = classnames_1.classNames((_a = {},
                _a[vdl_prefix_1.vdlPrefix('slider__dot')] = true,
                _a[vdl_prefix_1.vdlPrefix('slider__dot--active')] = isActive,
                _a[vdl_prefix_1.vdlPrefix('slider__dot--min')] = point === min,
                _a[vdl_prefix_1.vdlPrefix('slider__dot--max')] = point === max,
                _a));
            return (React.createElement("div", { className: pointClassName, style: style, key: point }));
            var _a;
        });
        return (React.createElement("div", { className: vdl_prefix_1.vdlPrefix('slider__steps') }, elements));
    };
    return Steps;
}(React.Component));
exports.Steps = Steps;



//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-components/lib/slider/steps.js
// module id = 609
// module chunks = 0 1 2 3 4 5 6